import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🚀", key: "setUpInMinutes" },
  { emoji: "🧽", key: "cleanVehicleTimeline" },
  { emoji: "🛡️", key: "fewerCostlyMisses" },
  { emoji: "🏁", key: "fullControl" },
]

export default function CarsSuccessSignalPage() {
  return (
    <RadioCardListPage translationKey="carsSuccessSignal" options={OPTIONS} />
  )
}
